import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

const Requests = ({moduleType}) => {
  return (
    <div className="mb-3 m-1">
      <div className="card">
        <div className="card-header text-center">
          Compras, fraccionamiento y retiros
        </div>
        <div className="card-body">
          <div className="row">
            <div className="text-center">
              <h3>4</h3>
              <div className="col-sm text-center">Fraccionamiento</div>
            </div>
            <div className="text-center">
              <h3>3</h3>
              <div className="col-sm text-center">Compras</div>
            </div>
            <div className="text-center">
              <h3>5</h3>
              <div className="col-sm text-center">Retiros</div>
            </div>
            <div className="text-center">
              <h3>2</h3>
              <div className="col-sm text-center">Reportes</div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm text-center mt-3 mb-1">
              <Link to={`/admin/warehouse/requests/${moduleType}`}>
                <Button variant="contained" color="primary">
                  Ver detalle
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Requests;

Requests.propTypes = {
  title: PropTypes.string,
  closeModal: PropTypes.bool,
  id_therapy: PropTypes.number,
  id_paquetizacion: PropTypes.number
};
